import React from 'react'
import '../header_footer.css'

const Footer = () => {
  return (
    <div className='footer-container'>Powered By TechElecon Pvt. Ltd. </div>
  )
}

export default Footer